module.exports = __webpack_public_path__ + "static/media/tablet.01e00442.jpg";